/* PDP Luxe v3: Kaching-variantdropdowns als segmentknoppen (zoals de mockup).
   De knoppen sturen de echte Kaching-combobox aan, dus winkelmand en korting blijven van Kaching. */
(function () {
  if (window.lxKachingNative) return; // v3.5: Kaching-bundels in hun eigen app-opmaak, deze restyle staat uit
  var OPTS = window.lxOpts || {};
  var GEUR = {
    'Naturel': 'Geurloos. Je ruikt alleen de zachte, roomachtige tallow zelf.',
    'Vanille Sinaasappel': 'Warme vanille met een frisse zweem sinaasappel. Zacht, niet zoet.',
    'Vanilla Spice': 'Vanille met kaneel en kruidnagel. Warm en kruidig, fijn voor de winter.'
  };
  var busy = false, queued = false;

  function pick(dd, val) {
    if (dd.getAttribute('data-value') === val || busy) return;
    var cb = dd.querySelector('[role=combobox]');
    if (!cb) return;
    busy = true;
    document.documentElement.classList.add('lx-switching');
    cb.click();
    setTimeout(function () {
      var lb = document.getElementById(cb.getAttribute('aria-controls'));
      var opt = lb && Array.prototype.find.call(lb.querySelectorAll('[role=option]'), function (o) { return o.getAttribute('data-value') === val; });
      if (opt) opt.click(); else cb.click();
      setTimeout(function () {
        document.documentElement.classList.remove('lx-switching');
        busy = false;
        enhance();
      }, 60);
    }, 40);
  }

  function enhance() {
    document.querySelectorAll('.kaching-bundles__swatch-dropdown').forEach(function (dd) {
      var vals = OPTS[dd.getAttribute('data-name')];
      var cur = dd.getAttribute('data-value');
      if (!vals || vals.length < 2 || vals.length > 4 || vals.indexOf(cur) < 0) return;
      if (!dd.classList.contains('lx-hide-dd')) dd.classList.add('lx-hide-dd');
      var seg = dd.parentElement.querySelector(':scope > .lx-seg');
      if (!seg) {
        seg = document.createElement('div');
        seg.className = 'lx-seg';
        seg.style.gridTemplateColumns = 'repeat(' + vals.length + ',1fr)';
        vals.forEach(function (v) {
          var b = document.createElement('button');
          b.type = 'button'; b.textContent = v; b.setAttribute('data-v', v);
          b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); pick(dd, v); });
          seg.appendChild(b);
        });
        dd.after(seg);
      }
      seg.querySelectorAll('button').forEach(function (b) {
        var on = String(b.getAttribute('data-v') === cur);
        if (b.getAttribute('aria-pressed') !== on) b.setAttribute('aria-pressed', on);
      });
      var content = dd.closest('.kaching-bundles__bar-variant__content');
      var num = content && content.querySelector('.kaching-bundles__bar-variant-number');
      if (num) {
        var ch = num.querySelector('.lx-chosen');
        if (!ch) { ch = document.createElement('b'); ch.className = 'lx-chosen'; num.appendChild(ch); }
        if (ch.textContent !== cur) ch.textContent = cur;
      }
    });

    document.querySelectorAll('.kaching-bundles__bar-variants').forEach(function (vw) {
      if (vw.querySelector(':scope > .lx-vhead')) return;
      var dd = vw.querySelector('.kaching-bundles__swatch-dropdown');
      var vals = dd && OPTS[dd.getAttribute('data-name')];
      if (!vals || vals.length < 2) return;
      var n = vw.querySelectorAll('.kaching-bundles__bar-variant-selector-wrapper').length;
      var name = dd.getAttribute('data-name').toLowerCase();
      var h = document.createElement('div');
      h.className = 'lx-vhead';
      var t = document.createElement('span');
      t.textContent = n > 1 ? 'Kies een ' + name + ' per pot' : 'Kies je ' + name;
      h.appendChild(t);
      if (vals.every(function (v) { return GEUR[v]; })) {
        var a = document.createElement('button');
        a.type = 'button'; a.className = 'lx-info-btn'; a.textContent = 'Wat ruik ik?';
        var info = document.createElement('div');
        info.className = 'lx-info'; info.hidden = true;
        info.innerHTML = vals.map(function (v) { return '<p><b>' + v + '</b> · ' + GEUR[v] + '</p>'; }).join('') +
          '<small>De geur komt alleen van natuurlijke etherische oliën, nooit synthetisch parfum.</small>';
        a.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); info.hidden = !info.hidden; });
        h.appendChild(a);
        vw.prepend(info);
      }
      vw.prepend(h);
    });
  }


  /* ---------- Menogarden-stijl: aanbiedingen als tegels + cadeaurij ---------- */
  var SHIP_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>';
  function price(el) {
    if (!el) return 0;
    var t = el.textContent.replace(/[^\d,.]/g, '').replace(/\.(?=\d{3})/g, '').replace(',', '.');
    return parseFloat(t) || 0;
  }
  function txt(el) { return el ? el.textContent.trim() : ''; }

  function tiles() {
    document.querySelectorAll('.kaching-bundles__block').forEach(function (blk) {
      var barsEl = blk.querySelector('.kaching-bundles__bars');
      var bars = barsEl ? Array.prototype.slice.call(barsEl.querySelectorAll(':scope > .kaching-bundles__bar')) : [];
      if (bars.length < 2 || bars.length > 4) return;
      if (!blk.classList.contains('lx-tiles')) blk.classList.add('lx-tiles');
      if (barsEl.style.getPropertyValue('--lx-n') !== String(bars.length)) barsEl.style.setProperty('--lx-n', bars.length);
      if (!blk.querySelector(':scope > .lx-choose')) {
        var c = document.createElement('div'); c.className = 'lx-choose'; c.innerHTML = '<span>Kies je aanbod</span>';
        blk.insertBefore(c, barsEl);
      }
      var sel = -1;
      bars.forEach(function (bar, i) {
        var main = bar.querySelector('.kaching-bundles__bar-main');
        if (!main) return;
        if (bar.classList.contains('kaching-bundles__bar--selected')) sel = i;
        var qty = parseInt(txt(bar.querySelector('.kaching-bundles__bar-title')), 10) || 1;
        if (!main.querySelector('.lx-tier-img')) {
          var bimgs = Array.prototype.map.call(bar.querySelectorAll('img.kaching-bundles__bundle-products__image'), function (x) { return x.src.replace(/height=\d+/, 'height=500'); });
          var srcs = bimgs.length ? bimgs.slice(0, 3) : [];
          if (!srcs.length && window.lxImg) for (var k = 0; k < Math.min(qty, 3); k++) srcs.push(window.lxImg);
          if (srcs.length) {
            var w = document.createElement('div'); w.className = 'lx-tier-img' + (bimgs.length ? ' lx-mix' : '');
            srcs.forEach(function (src) { var im = document.createElement('img'); im.src = src; im.alt = ''; im.loading = 'lazy'; w.appendChild(im); });
            main.insertBefore(w, main.firstChild);
          }
        }
        var p = price(bar.querySelector('.kaching-bundles__bar-price')), f = price(bar.querySelector('.kaching-bundles__bar-full-price'));
        var save = (p && f && f > p) ? 'Bespaar ' + Math.round((1 - p / f) * 100) + '%' : '';
        var pill = main.querySelector('.lx-save');
        if (save) {
          if (!pill) { pill = document.createElement('div'); pill.className = 'lx-save'; main.appendChild(pill); }
          if (pill.textContent !== save) pill.textContent = save;
        } else if (pill) pill.remove();
        var tagTxt = (i === bars.length - 1) ? 'Beste deal' : (bars.length > 2 && i === 1) ? 'Meest gekozen' : '';
        if (tagTxt && !main.querySelector('.lx-tag')) {
          var t = document.createElement('div'); t.className = 'lx-tag'; t.textContent = tagTxt;
          main.insertBefore(t, main.firstChild);
        }
      });
      gifts(blk, bars, sel);
      contents(blk, barsEl, bars, sel);
    });
  }


  /* combi-bundel: donkere regel "Zit erin" onder de tegels i.p.v. het witte Kaching-paneel */
  function contents(blk, barsEl, bars, sel) {
    var bar = bars[sel];
    var names = bar ? Array.prototype.map.call(bar.querySelectorAll('.kaching-bundles__bundle-products__title'), function (t) { return t.textContent.trim(); }).filter(Boolean) : [];
    var row = blk.querySelector(':scope > .lx-contents');
    if (names.length < 2) { if (row) row.remove(); return; }
    var sig = names.join('|');
    if (row && row.getAttribute('data-sig') === sig) return;
    if (!row) { row = document.createElement('div'); row.className = 'lx-contents'; barsEl.after(row); }
    row.setAttribute('data-sig', sig);
    row.innerHTML = '<span class="lx-ct-l">Zit erin</span><span class="lx-ct-v">' + names.map(function (n) { return '<span>' + n + '</span>'; }).join('<i>+</i>') + '</span>';
  }

  function gifts(blk, bars, sel) {
    var list = [];
    function add(key, g, i) {
      var ex = list.filter(function (x) { return x.key === key; })[0];
      if (ex) { if (ex.bars.indexOf(i) < 0) ex.bars.push(i); } else { g.key = key; g.bars = [i]; list.push(g); }
    }
    bars.forEach(function (bar, i) {
      bar.querySelectorAll('.kaching-bundles__free-gift').forEach(function (g) {
        var t = txt(g.querySelector('.kaching-bundles__free-gift__text')).replace(/^\+\s*/, '').replace(/^gratis\s*/i, '');
        var img = g.querySelector('img');
        var src = img ? img.src.split('?')[0] : '';
        var generic = !t || /^(free\s*gift|gratis\s*cadeau|cadeau|gift)$/i.test(t.trim());
        var key = src || t.toLowerCase();               // zelfde productfoto = zelfde cadeau
        var ex = list.filter(function (x) { return x.key === key; })[0];
        if (ex && generic) { if (ex.bars.indexOf(i) < 0) ex.bars.push(i); return; }
        if (ex && !generic && ex.generic) { ex.t = t.charAt(0).toUpperCase() + t.slice(1); ex.generic = false; }
        add(key, { t: generic ? (img && img.alt ? img.alt : 'Gratis cadeau') : t.charAt(0).toUpperCase() + t.slice(1), generic: generic, img: img ? img.src : '', fp: txt(g.querySelector('.kaching-bundles__free-gift__full-price')) }, i);
      });
      if (/gratis verzending/i.test(txt(bar.querySelector('.kaching-bundles__bar-subtitle')))) add('ship', { t: 'Gratis verzending', ship: true, fp: '€4,95' }, i);
    });
    var head = blk.querySelector(':scope > .lx-gifts-t'), row = blk.querySelector(':scope > .lx-gifts');
    if (!list.length) { if (head) head.remove(); if (row) row.remove(); return; }
    var sig = JSON.stringify(list.map(function (x) { return [x.key, x.bars]; })) + '|' + sel;
    if (row && row.getAttribute('data-sig') === sig) return;
    if (!row) {
      head = document.createElement('div'); head.className = 'lx-gifts-t'; head.textContent = 'Cadeau bij je aanbod';
      row = document.createElement('div'); row.className = 'lx-gifts';
      blk.appendChild(head); blk.appendChild(row);
    }
    row.setAttribute('data-sig', sig);
    row.style.gridTemplateColumns = 'repeat(' + list.length + ',1fr)';
    row.innerHTML = '';
    list.forEach(function (g) {
      var on = sel >= Math.min.apply(null, g.bars); // cadeau geldt vanaf zijn aanbod en alles daarboven (zoals Menogarden)
      var from = txt(bars[g.bars[0]].querySelector('.kaching-bundles__bar-title'));
      var d = document.createElement('div');
      d.className = 'lx-gift' + (on ? ' lx-on' : '');
      d.innerHTML = '<div class="lx-of">' + (on ? 'GRATIS' : 'Bij ' + from) + (g.fp ? ' <s>' + g.fp + '</s>' : '') + '</div>' +
        (g.ship ? SHIP_SVG : (g.img ? '<img src="' + g.img + '" alt="" loading="lazy">' : '')) + '<span>' + g.t + '</span>';
      row.appendChild(d);
    });
  }

  function schedule() {
    if (busy || queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; tiles(); enhance(); });
  }

  function start() {
    tiles(); enhance();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-value', 'class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Garantieregel: toevoeging weglaten als de regel anders op 2 regels komt. */
(function () {
  function fit() {
    document.querySelectorAll('.lx-trust li[data-lx-fit]').forEach(function (li) {
      var s = li.querySelector('span'), sub = li.querySelector('.lx-trust__sub');
      if (!s || !sub) return;
      sub.hidden = false;
      var b = s.querySelector('b');
      if (s.getBoundingClientRect().height > b.getBoundingClientRect().height * 1.5) sub.hidden = true;
    });
  }
  var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 150); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fit); else fit();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
})();
